<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="authorizeQuotation()" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isAuthorizeQuotationModalVisible" :vm-title="$t('quotations.authorize_title')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("projects.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('projects.name') })" v-model="form.name" :label='$t("projects.name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("strings.oc_number")' :danger="$v.form.number.$invalid && $v.form.number.$model" :danger-text="$t('validation.required', { attribute: $t('strings.oc_number') })" v-model="form.number" :label='$t("strings.oc_number")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalAuthorizeQuotation',
  mixins: [ModalMixin1],
  validations () {
    return {
      form: {
        name: {
          required
        },
        number: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isAuthorizeQuotationModalVisible'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setAuthorizeQuotationModalVisible',
      'actionRecord'
    ]),
    authorizeQuotation () {
      this.form.id && this.actionRecord({ id: this.form.id, action: 'authorize', name: this.form.name, number: this.form.number })
      this.setAuthorizeQuotationModalVisible(false)
    },
    close () {
      this.setAuthorizeQuotationModalVisible(false)
    }
  }
}
</script>
